import React from 'react';
import { Box, Typography } from '@mui/material';

// A compact panel header for MyAccount.js's dashboard content column —
// deliberately much lighter than EditorialSection (no huge display
// headline, no scroll-triggered fade-in, no full-bleed background band):
// EditorialSection was built for full-width public marketing pages, not a
// panel sitting next to a sidebar showing only one section at a time.
export default function AccountPanel({ kicker, title, intro, children }) {
  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        {kicker && (
          <Typography
            sx={{
              fontFamily: 'var(--font-mono)',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              color: 'var(--teal-500)',
              mb: 1,
            }}
          >
            {kicker}
          </Typography>
        )}
        <Typography
          sx={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: { xs: 26, md: 32 },
            lineHeight: 1.1,
            color: 'var(--navy-500)',
          }}
        >
          {title}
        </Typography>
        {intro && (
          <Typography color="text.secondary" sx={{ mt: 1, maxWidth: 640 }}>
            {intro}
          </Typography>
        )}
      </Box>
      {children}
    </Box>
  );
}
